import React from "react";
import classnames from "classnames";
import { FormattedMessage, injectIntl } from "react-intl";

import "./style.scss";

const Input = ({
  input = {},
  meta = { touched: false, error: null },
  label = "",
  containerClassName = "",
  value = "" as string | number,
  placeholder = "",
  intl: { formatMessage },
  ...props
}) => {
  const placeholderText = placeholder ? formatMessage({ id: placeholder }) : "";

  return (
    <div
      className={classnames("cnb-input", containerClassName, {
        error: meta.touched && meta.error,
      })}
    >
      {label && <FormattedMessage id={label} tagName="label" />}
      <input
        type={"number"}
        min={0}
        value={value}
        placeholder={placeholderText}
        {...input}
        {...props}
      />
      {meta.touched && meta.error && <span>{meta.error}</span>}
    </div>
  );
};

export default injectIntl(Input);
